import { createBrowserRouter } from "react-router-dom";
import AuthRoutes from "./AuthRoutes";
import AdminRoutes from "./AdminRoutes";
import NotFound from "../pages/notfound";
import SharedStatsPage from "../pages/shared/ShareStatsPage.jsx";
import SharedReport from "../pages/shared/SharedReport.jsx";
const router = createBrowserRouter([
  AuthRoutes,
  AdminRoutes,
  {
    path: "/shared-stats/:filterId",
    element: <SharedStatsPage />,
  },
  {
    path: "/report/shared/:token",
    element: <SharedReport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
export default router;
